export default {
  methods: {
    notify({
      text,
      type = 'success'
    }) {
      this.$store.commit('SET_NOTIFICATION', {
        text,
        type
      })
    }
  }
}
